import styled from '@emotion/styled';
import { flexCenter, flexCenterColumn } from '@seedlang/style_mixins';
import { isPresent } from '@seedlang/utils';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import Legend from 'components/visualization/legend';
import PieChart from 'components/visualization/pie_chart';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import { v4 as Uuid } from 'uuid';

const Wrapper = styled.div`
  ${flexCenterColumn()}
`;

const PieChartWrapper = styled.div`
  ${flexCenterColumn()}
`;

const KeyWrapper = styled.div`
  ${flexCenter()}
  margin: ${props => props.margin};
`;

const TextWrapper = styled.div`
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  margin: -5px 0 15px 0;
`;

@observer
class PieChartWithLegend extends React.Component {
  @observable id;

  constructor(props) {
    super(props);
    this.id = Uuid();
  }

  @computed get fontSize() {
    if (isPresent(this.props.fontSize)) {
      return this.props.fontSize;
    }
    const countCharLength = String(this.props.count || '').length;
    const maxFontSize = 45;
    const minFontSize = 30;
    const step = 5;
    // Scale down 5px per character beyond 2 chars, clamped to [minFontSize, maxFontSize]
    const size = Math.max(minFontSize, Math.min(maxFontSize, maxFontSize - Math.max(0, countCharLength - 2) * step));
    return `${size}px`;
  }

  render() {
    return (
      <Wrapper
        data-tip
        data-for={this.id}
      >
        <PieChartWrapper>
          <PieChart
            hideSlicesLabels
            hideTooltip
            fontSize={this.fontSize}
            colors={this.props.colors}
            data={this.props.data}
            width={this.props.width}
            count={this.props.count}
            margin={this.props.margin}
          />
          {
            this.props.tooltipText &&
              <ReactTooltip
                place='top'
                type='dark'
                id={this.id}
                class='custom-tooltip'
              >
                {this.props.tooltipText}
              </ReactTooltip>
          }
        </PieChartWrapper>
        {
          this.props.subText &&
            <TextWrapper>
              {this.props.subText}
            </TextWrapper>
        }
        <KeyWrapper>
          {
            this.props.legends.map(item => {
              return (
                <Legend
                  key={item[0]}
                  iconBackground={item[0]}
                  text={item[1]}
                />
              );
            })
          }
        </KeyWrapper>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(PieChartWithLegend);
